import { createElement, forwardRef } from "react";
const Circle = forwardRef((p, ref) => createElement("circle", { ...p, ref })), ClipPath = forwardRef((p, ref) => createElement("clipPath", { ...p, ref })), Defs = forwardRef((p, ref) => createElement("defs", { ...p, ref })), Ellipse = forwardRef((p, ref) => createElement("ellipse", { ...p, ref })), ForeignObject = forwardRef(
  (p, ref) => createElement("foreignObject", { ...p, ref })
), G = forwardRef((p, ref) => createElement("g", { ...p, ref })), Image = forwardRef((p, ref) => createElement("image", { ...p, ref })), Line = forwardRef((p, ref) => createElement("line", { ...p, ref })), LinearGradient = forwardRef(
  (p, ref) => createElement("linearGradient", { ...p, ref })
), Marker = forwardRef((p, ref) => createElement("marker", { ...p, ref })), Mask = forwardRef((p, ref) => createElement("mask", { ...p, ref })), Path = forwardRef((p, ref) => createElement("path", { ...p, ref })), Pattern = forwardRef((p, ref) => createElement("pattern", { ...p, ref })), Polygon = forwardRef((p, ref) => createElement("polygon", { ...p, ref })), Polyline = forwardRef((p, ref) => createElement("polyline", { ...p, ref })), RadialGradient = forwardRef(
  (p, ref) => createElement("radialGradient", { ...p, ref })
), Rect = forwardRef((p, ref) => createElement("rect", { ...p, ref })), Shape = forwardRef((p, ref) => createElement("shape", { ...p, ref })), Stop = forwardRef((p, ref) => createElement("stop", { ...p, ref })), Svg = forwardRef((p, ref) => createElement("svg", { ...p, ref })), Symbol = forwardRef((p, ref) => createElement("symbol", { ...p, ref })), Text = forwardRef((p, ref) => createElement("text", { ...p, ref })), TextPath = forwardRef((p, ref) => createElement("clipPath", { ...p, ref })), TSpan = forwardRef((p, ref) => createElement("tSpan", { ...p, ref })), Use = forwardRef((p, ref) => createElement("use", { ...p, ref }));
var src_default = Svg;
export {
  Circle,
  ClipPath,
  Defs,
  Ellipse,
  ForeignObject,
  G,
  Image,
  Line,
  LinearGradient,
  Marker,
  Mask,
  Path,
  Pattern,
  Polygon,
  Polyline,
  RadialGradient,
  Rect,
  Shape,
  Stop,
  Svg,
  Symbol,
  TSpan,
  Text,
  TextPath,
  Use,
  src_default as default
};
//# sourceMappingURL=index.js.map
